/**
 * Dependencies
 */
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import initBaseStyles from '@nerdwallet/base-styles/init';
import { initBrowserEvents } from '@nerdwallet/analytics';
import arrayFrom from 'array.from';
import { setSentryClient } from '@nerdwallet/logging';
import { initSentryBrowser } from '@nerdwallet/sentry';
import * as Sentry from '@sentry/browser';

import routeDefinitions from './routes/index';

if (!Array.from) arrayFrom.shim();

initBaseStyles();
initBrowserEvents();
initSentryBrowser();
setSentryClient(Sentry);

// Webpack lets us us embed styles and assets within the code.
require('@nerdwallet/base-styles/reset.css');
require('@nerdwallet/base-styles/base.css');
require('./styles/main.less');

const Main = () => <Router>{routeDefinitions}</Router>;

export default Main;
